import React, { FunctionComponent } from 'react'
import { Timestamps } from '../../service/Timestamps'
import { AISparklesIcon } from '../Icons/Icons'
import styles from './KeyInsights.module.css'

interface Props {
  insights: string[]
  createdAt?: string
}

// KeyInsights renders the customer-facing insights from the health check
export const KeyInsights: FunctionComponent<Props> = ({ insights, createdAt }) => (
  <div data-testid='key-insights' className={styles.sectionWrapper}>
    <div className={styles.headerRow}>
      <span className={`blk subdued ${styles.headerLabel}`}>Key insights and suggestions</span>
      <span className={styles.aiAccent}>
        <AISparklesIcon />
      </span>
    </div>

    <div className={`surface ${styles.surfaceContainer}`}>
      {insights.length > 0 ? (
        <ul className={styles.insightsList}>
          {insights.map((insight, index) => (
            <li key={index}>{insight}</li>
          ))}
        </ul>
      ) : (
        <p className='blk subdued no-margin-bottom'>No insights available.</p>
      )}

      {createdAt && (
        <p className={`blk subdued no-margin-bottom ${styles.createdAt}`}>
          Created at {Timestamps.format(new Date(createdAt))}
        </p>
      )}
    </div>
  </div>
)
